<template>
    <div class="black-bg">
        <div v-if="isAccountLoaded">
            <top-bar
                activeTab="campaign"
                class="d-none"
                :lbl="lbl"
                :isLogin="isLogin"
            ></top-bar>
            <div v-if="campaign != null">
                <CampaignPicture
                    class="layout-picture box-picture d-none"
                    imgClass="default"
                    :campaignImage="campaign.pictures"
                ></CampaignPicture>
                <DetailInfo
                    class="layout-info"
                    :lbl="lbl"
                    :campaign="campaign"
                    :hideCondition="false"
                ></DetailInfo>
                <DetailAndCondition
                    class="d-none"
                    :lbl="lbl"
                    :campaign="campaign"
                ></DetailAndCondition>
                <div v-if="Object.keys(profile).length > 0">
                    <RedeemButton
                        class="layout-redeem"
                        v-if="campaign.type != 16 && campaign.type != 0"
                        :campaign="campaign"
                        :isLogin="isLogin"
                        :profile="profile"
                        :lblRedeemBTN="lbl.redeem_button"
                        :detailController="detailController"
                        :redeemController="redeemController"
                        :modalController="modalController"
                        @clickRedeem="clickRedeem()"
                    ></RedeemButton>
                    <RedeemButtonDraw
                        class="layout-redeem-draw"
                        v-if="campaign.type != 16 && campaign.type == 0"
                        :campaign="campaign"
                        :isLogin="isLogin"
                        :profile="profile"
                        :lblRedeemBTN="lbl.redeem_button"
                        :detailController="detailController"
                        :redeemController="redeemController"
                        :modalController="modalController"
                        @clickRedeem="clickRedeem()"
                    >
                    </RedeemButtonDraw>
                </div>
            </div>
            <ModalMaster class="d-none" :controller="modalController" />
        </div>
    </div>
</template>
<script>
//helper
// import Account from "@/helper/AccountHelper.js";
import AccountHelper from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import CampaignPicture from "../component/detail/PictureDetail.vue";
import DetailInfo from "../component/detail/DetailInfo.vue";
import DetailAndCondition from "../component/detail/DetailAndCondition.vue";
import RedeemButton from "../component/detail/RedeemButton.vue";
import RedeemButtonDraw from "../component/detail/RedeemButtonDraw.vue";
//controller
import { DetailController } from "../controller/DetailController.js";
import { RedeemController } from "../controller/RedeemController.js";
//service
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";

import BzbsApi from "@/core/Account/service/BzbsProfile.js";

export default {
    name: "Campaign",
    mixins: [Mixin, AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        TopBar,
        CampaignPicture,
        DetailInfo,
        DetailAndCondition,
        RedeemButton,
        RedeemButtonDraw
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),
            cacheHelper: new CacheHelper(),
            profile: {},
            campaign: null
        };
    },
    created: function() {
        this.getProfile();
        this.initialIsFromLanding();
    },
    mounted() {
        AccountHelper.bzbsAnalyticTracking({
            ScreenName: "campaign_detail",
            Category: "campaigndetail",
            Event: "view_campaign",
            Action: "view",
            ContactNumber: ""
        });
    },
    methods: {
        //Profile
        getProfile() {
            BzbsApi.getProfile(this.cacheHelper.getCache("BzbsUser").token)
                .then(response => {
                    this.profile = response.data;
                    // console.log(this.profile)
                })
                .catch(err => {
                    this.errorResponse(err.response.data.error);
                });
        },
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        accountInitiated: function() {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function() {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function() {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(
                cacheHelper.getCache("isfromlanding")
            );

            if (formLanding != null) {
                cacheHelper.removeCache("isfromlanding");

                if (formLanding.page == "wodd") {
                    return;
                }
                var backAmount = formLanding.page == "interface" ? -3 : -2;
                history.go(backAmount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.loadingModal.show();
            this.handleLoading(true);
            this.detailController
                .initial(this.campaignConfig)
                .then(campaign => {
                    this.campaign = campaign;
                    this.redeemController.initial(
                        this.campaign,
                        this.modalController
                    );
                    this.setRedeemEvent();
                })
                .catch(err => {
                    this.errorResponse(err);
                })
                .finally(() => {
                    this.loadingModal.hide();
                    this.handleLoading(false);
                });
        },
        //#endregion setup

        //#region event
        clickRedeem: function() {
            var selectCampaignId = this.detailController.selectedCampaignId;
            var selectedQuantity = this.detailController.selectedQuantity;
            var selectedType = this.detailController.type;
            this.redeemController.clickRedeem(
                selectCampaignId,
                selectedQuantity,
                null,
                selectedType
            );
        },
        setRedeemEvent: function() {
            this.redeemController.onClickRedeem = () => {
                AccountHelper.bzbsAnalyticTracking({
                    ScreenName: "campaign_detail",
                    Category: "campaigndetail",
                    Event: "click_redeem",
                    Action: "on click",
                    ContactNumber: ""
                });
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                AccountHelper.bzbsAnalyticTracking({
                    ScreenName: "campaign_detail",
                    Category: "campaigndetail",
                    Event: "redeem_success",
                    Action: "on click",
                    ContactNumber: ""
                });
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.loadingModal.hide();
                return true;
            };
        }
        //#endregion event
    }
};
</script>
<style lang="scss" scoped>
.black-bg {
    background-color: #000;
}

.box-picture {
    padding: 0 20px;

    .owl-theme .owl-dots .owl-dot.active span {
        background: #f06634;
    }

    .owl-theme .owl-dots .owl-dot span {
        width: 8px;
        height: 8px;
        margin: 5px 2px;
    }

    .owl-theme .owl-nav.disabled + .owl-dots {
        margin-top: 6px;
    }
}
</style>
